var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 481.43 481.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00ad81;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.31 284.85 196.61 383.13 98.31 481.43 0.02 383.1 98.31 284.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "240.69 142.41 339.04 240.71 240.69 339.07 142.38 240.76 240.69 142.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.31 0 196.65 98.33 98.31 196.68 0 98.35 98.31 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.08 284.8 481.43 383.1 383.08 481.47 284.78 383.13 383.08 284.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.08 196.68 284.78 98.35 383.08 0.04 481.38 98.35 383.08 196.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 425.29,
    y: 217.52,
    width: 46.5,
    height: 46.44,
    transform: "translate(-38.79 387.88) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 359.83,
    y: 217.52,
    width: 46.5,
    height: 46.44,
    transform: "translate(-57.98 341.58) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.08,
    y: 217.52,
    width: 46.5,
    height: 46.44,
    transform: "translate(-141.47 140.14) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.62,
    y: 217.52,
    width: 46.5,
    height: 46.44,
    transform: "translate(-160.66 93.84) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.85 448.54 240.68 415.69 273.54 448.59 240.72 481.43 207.85 448.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.85 383.09 240.68 350.24 273.54 383.13 240.72 415.98 207.85 383.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217.48,
    y: 75.11,
    width: 46.44,
    height: 46.5,
    transform: "translate(0.99 199.1) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217.48,
    y: 9.65,
    width: 46.44,
    height: 46.5,
    transform: "translate(47.29 179.91) rotate(-45.02)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.6afdde10a47585174a406bbcea557e6c.svg";
export { ForwardRef as ReactComponent };